import { ContentHoverEditButtonProps } from '@framework/ui';
import { Col } from 'antd';
import { IMultiPreferenceWidget } from '../IMultiPreferenceWidget';
import { MultiPreferenceRowWrapper } from './MultiPreferenceRowWrapper';

export interface IMultiPreferenceRowLabelsProps
  extends Omit<ContentHoverEditButtonProps, 'children'> {
  widget: IMultiPreferenceWidget;
}

export function MultiPreferenceRowLabels(
  props: Readonly<IMultiPreferenceRowLabelsProps>,
) {
  const { widget } = props;

  const labels = widget.cascade?.fields.map(c => {
    return { label: c.label, index: c.index };
  });
  if (!labels || labels?.length === 0) return null;

  return (
    <>
      <MultiPreferenceRowWrapper index={-1} readonly isLabelRow>
        {labels.map(label => {
          return (
            <Col key={label.index}>
              <div>{label.label}</div>
            </Col>
          );
        })}
      </MultiPreferenceRowWrapper>
    </>
  );
}
